import { render, staticRenderFns } from "./TransferStock.vue?vue&type=template&id=ea55863c"
import script from "./TransferStock.vue?vue&type=script&lang=js"
export * from "./TransferStock.vue?vue&type=script&lang=js"
import style0 from "./TransferStock.vue?vue&type=style&index=0&id=ea55863c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports